import { useEffect } from "react";

export const useNavbarUserBootstrap = ({ user, updateUser }) => {
  useEffect(() => {
    if (user) return;

    const storedUserInfo = localStorage.getItem("userInfo");

    if (!storedUserInfo) return;

    try {
      const parsedUser = JSON.parse(storedUserInfo);

      if (parsedUser) {
        updateUser(parsedUser);
      }
    } catch (error) {
      console.error(
        "Erreur lors du parsing des informations utilisateur:",
        error
      );
    }
  }, [user, updateUser]);
};